<template>
  <div>
    <div @click="showDialog">
      <slot></slot>
    </div>
    <el-dialog
      title="添加教师"
      :visible.sync="dialogVisible"
      append-to-body
      width="656px"
      @close="handleCancel"
    >
      <el-form size="mini" :model="searchInfo" inline @submit.native.prevent>
        <el-form-item label="教师搜索" prop="key_word">
          <el-input
            v-model="searchInfo.key_word"
            placeholder="教师姓名/手机号"
            @change="handleSearch"
            prefix-icon="el-icon-search"
            clearable
            maxlength="99"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="selected-list">
        <p class="title">
          已选择教师：已选择<span class="mwow-green">{{
            selectedList.length
          }}</span
          >人
        </p>
        <div class="tabs">
          <span
            :class="`tab ${item.conflict ? 'mwow-red' : ''}`"
            v-for="item in selectedList"
            :key="item.teacher_id"
            >{{ item.name
            }}<i class="el-icon-error" @click="handleTeacherSelect(item)"></i
          ></span>
        </div>
      </div>
      <el-table
        size="mini"
        v-horizontal-scroll
        :data="tableData"
        stripe
        style="width: 100%"
        tooltip-effect="dark"
        class="mwow-table micro"
      >
        <el-table-column width="42" align="center">
          <template slot-scope="scope">
            <el-checkbox
              v-model="scope.row.checked"
              @change="handleTeacherSelect(scope.row)"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="教师姓名" prop="name"></el-table-column>
        <el-table-column label="手机号" prop="mobile"></el-table-column>
        <el-table-column label="状态" prop="conflict">
          <template slot-scope="scope">
            <span class="mwow-red" v-if="scope.row.conflict"
              ><i class="dot red"></i>冲突</span
            >
            <span class="mwow-green" v-else><i class="dot green"></i>空闲</span>
          </template>
        </el-table-column>
        <el-table-column label="固定休息时间" prop="resting_time">
          <template slot-scope="scope">
            <div>
              {{
                scope.row.resting_time
                  .map((item) => {
                    return weekArr[item];
                  })
                  .join("、") || "-"
              }}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div style="overflow: hidden">
        <el-pagination
          :current-page="page"
          :page-size="pageSize"
          :page-sizes="pageSizeArray"
          :pager-count="5"
          :style="{ float: 'right', padding: '20px' }"
          :total="total"
          @current-change="handlePagerChange"
          @size-change="handlePagerSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
      <div class="footer">
        <div class="btns">
          <el-button class="mwow-button-filled mini" @click="handleCancel"
            >取消</el-button
          >
          <el-button
            class="mwow-button-filled success mini"
            @click="handleConfirm"
            >保存</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  teacherSelectListWithConflict,
  teachersWithConflict,
} from "@/api/classSchedule";

export default {
  // @Prop() originOption!: any;
  // @Prop() classId!: number;
  // @Prop() originData!: any[];
  props: ["originOption", "classId", "originData"],
  data() {
    return {
      weekArr: [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ],
      selectedObject: {},
      selectedList: [],
      dialogVisible: false,
      searchInfo: {
        key_word: "",
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      conflictOption: {}, // 判断冲突的相关参数
    };
  },

  // @Watch("originOption", { immediate: false, deep: true })
  // onOriginOptionChange(n: any) {
  //   // console.log(this.originData);
  //   this.selectedList = this.originData;
  //   const obj: any = {};
  //   this.originData.map((item: any) => {
  //     obj[item.teacher_id] = item;
  //   });
  //   this.selectedObject = obj;
  //   // 外部参数变化后，更新当前选中项的冲突状态
  //   this.conflictOption = n;
  //   this.handleCheckConflict();
  // }
  watch: {
    originOption: {
      handler(n, o) {
        // console.log(this.originData);
        this.selectedList = this.originData;
        const obj = {};
        this.originData.map((item) => {
          obj[item.teacher_id] = item;
        });
        this.selectedObject = obj;
        // 外部参数变化后，更新当前选中项的冲突状态
        this.conflictOption = n;
        this.handleCheckConflict();
      },
    },
    immediate: false,
    deep: true,
  },
  methods: {
    showDialog() {
      this.dialogVisible = true;
      this.selectedList = this.originData;
      const obj = {};
      this.originData.map((item) => {
        obj[item.teacher_id] = item;
      });
      this.selectedObject = obj;
      this.handleSearch();
      // 读取外部参数
      this.conflictOption = { ...this.originOption };
      this.handleCheckConflict();
    },
    handleCancel() {
      this.dialogVisible = false;
      this.searchInfo.key_word = "";
    },
    handleConfirm() {
      this.dialogVisible = false;
      this.$emit("change", this.selectedList);
    },
    handleCheckConflict() {
      if (
        !this.classId ||
        this.selectedList.length === 0 ||
        !this.conflictOption
      ) {
        return false;
      }
      teachersWithConflict({
        class_id: this.classId,
        teacher_ids: this.selectedList.map((item) => {
          return item.teacher_id;
        }),
        ...this.conflictOption,
      }).then((res) => {
        if (res.error_code === 0) {
          this.selectedList = res.data.list;
          const obj = {};
          res.data.list.map((item) => {
            obj[item.teacher_id] = item;
          });
          this.selectedObject = obj;
          this.$emit("change", res.data.list);
        }
      });
    },
    handleTeacherSelect(row) {
      const copy = { ...this.selectedObject };
      if (copy[row.teacher_id]) {
        delete copy[row.teacher_id];
      } else {
        copy[row.teacher_id] = row;
      }
      this.selectedObject = copy;
      const items = [];
      for (const key in copy) {
        items.push(copy[key]);
      }
      this.selectedList = items;
      const index = this.tableData.findIndex((item) => {
        return item.teacher_id === row.teacher_id;
      });
      if (index >= 0) {
        this.tableData[index].checked = !!copy[row.teacher_id];
      }
    },
    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    getList(params) {
      const option = {
        page: params.page,
        page_size: params.page_size,
        class_id: this.classId,
        ...this.conflictOption,
      };
      if (this.searchInfo.key_word) {
        option.key_word = this.searchInfo.key_word;
      }
      teacherSelectListWithConflict(option).then((res) => {
        res.data.list.map((item) => {
          if (this.selectedObject[item.teacher_id]) {
            item.checked = true;
          } else {
            item.checked = false;
          }
        });
        this.tableData = res.data.list;
        this.total = res.data.total;
        this.page = res.data.page;
      });
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.selected-list {
  line-height: 13px;
  font-size: 12px;
  color: #5c5d5e;
  .title {
    margin-bottom: 14px;
    span {
      margin: 0 4px;
    }
  }
  .tabs {
    margin-left: 60px;
    .tab {
      color: #07d1aa;
      border: 1px solid #e7e8ea;
      border-radius: 4px;
      line-height: 28px;
      padding: 0 8px;
      margin-right: 10px;
      margin-bottom: 14px;
      display: inline-block;
      i {
        margin-left: 4px;
        cursor: pointer;
        color: #d8d8d8;
      }
    }
  }
}
.footer {
  margin: 0 -20px;
  border-top: 1px solid #e7e8ea;
  padding: 20px 20px 0 20px;
  .btns {
    text-align: right;
    .mwow-button-filled {
      margin-left: 10px;
    }
  }
}
.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 4px;
  &.red {
    background-color: #f56c6c;
  }
  &.green {
    background-color: #07d1aa;
  }
}
</style>
